document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded and parsed');
  
  // Debug: Check if elements exist
  const swiperContainer = document.querySelector('.before-after-swiper');
  const prevButton = document.querySelector('.swiper-button-prev');
  const nextButton = document.querySelector('.swiper-button-next');
  const prevMobile = document.querySelector('.swiper-button-prev--mobile');
  const nextMobile = document.querySelector('.swiper-button-next--mobile');
  
  // Get the number of slides
  const slidesCount = swiperContainer ? parseInt(swiperContainer.dataset.slidesCount) || 1 : 1;
  const hasMultipleSlides = slidesCount > 1;
  
  // Initialize main slider
  const mainSwiper = new Swiper('.before-after-swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: hasMultipleSlides,
    grabCursor: true,
    speed: 600,
    autoplay: hasMultipleSlides ? {
      delay: 5000,
      disableOnInteraction: false,
    } : false,
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next, .swiper-button-next--mobile',
      prevEl: '.swiper-button-prev, .swiper-button-prev--mobile',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });
  
  console.log('Swiper initialized:', mainSwiper);
  console.log('Navigation elements connected:', {
    nextEl: mainSwiper.navigation?.nextEl,
    prevEl: mainSwiper.navigation?.prevEl
  });
  
  // Manual navigation button handlers
  if (prevButton) {
    prevButton.addEventListener('click', function() {
      console.log('Prev button clicked');
      mainSwiper.slidePrev();
    });
  }
  
  if (nextButton) {
    nextButton.addEventListener('click', function() {
      console.log('Next button clicked');
      mainSwiper.slideNext();
    });
  }
  
  if (prevMobile) {
    prevMobile.addEventListener('click', function() {
      console.log('Prev mobile clicked');
      mainSwiper.slidePrev();
    });
  }
  
  if (nextMobile) {
    nextMobile.addEventListener('click', function() {
      console.log('Next mobile clicked');
      mainSwiper.slideNext();
    });
  }
  
  // Modal functionality
  const modal = document.querySelector('.before-after-modal');
  const modalClose = document.querySelector('.modal-close');
  const modalPrevBtn = document.querySelector('.modal-button-prev');
  const modalNextBtn = document.querySelector('.modal-button-next');
  const modalSlides = document.querySelectorAll('.modal-slide');
  const currentSlideEl = document.querySelector('.current-slide');
  const totalSlidesEl = document.querySelector('.total-slides');
  let currentSlideIndex = 0;
  const totalSlides = modalSlides.length;
  
  // Ensure all modal elements exist
  if (!modal) console.error('Modal not found!');
  if (!modalClose) console.error('Close button not found!');
  if (!modalPrevBtn) console.error('Previous button not found!');
  if (!modalNextBtn) console.error('Next button not found!');
  if (modalSlides.length === 0) console.error('No slides found!');
  
  // Show a specific slide in the modal
  function showSlide(index) {
    // Hide all slides
    modalSlides.forEach(slide => {
      slide.classList.remove('active');
    });
    
    // Show the selected slide
    if (modalSlides[index]) {
      modalSlides[index].classList.add('active');
    }
    
    // Update counter
    currentSlideIndex = index;
    currentSlideEl.textContent = index + 1;
  }
  
  // Open modal when clicking on slider item
  const slides = document.querySelectorAll('.before-after-swiper .swiper-slide');
  slides.forEach((slide, index) => {
    slide.addEventListener('click', () => {
      openModal(index);
    });
  });
  
  // Modal navigation with debug
  if (modalPrevBtn) {
    console.log('Previous button found');
    modalPrevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      console.log('Previous button clicked');
      let newIndex = currentSlideIndex - 1;
      if (newIndex < 0) newIndex = totalSlides - 1;
      showSlide(newIndex);
    });
  }
  
  if (modalNextBtn) {
    console.log('Next button found');
    modalNextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      console.log('Next button clicked');
      let newIndex = currentSlideIndex + 1;
      if (newIndex >= totalSlides) newIndex = 0;
      showSlide(newIndex);
    });
  }
  
  // Close modal - only with X button
  modalClose.addEventListener('click', closeModal);
  
  function openModal(index) {
    // Modal now works on all screen sizes
    modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
    showSlide(index);
    
    // Prevent modal from closing when clicking on overlay
    document.querySelector('.modal-overlay').addEventListener('click', function(e) {
      // Only allow propagation if it's the close button
      if (e.target.closest('.modal-close')) {
        return;
      }
      // Otherwise prevent event from bubbling up
      e.stopPropagation();
    });
  }
  
  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  }
  
  // Handle window resize
  window.addEventListener('resize', () => {
    if (mainSwiper) {
      mainSwiper.update();
    }
    
    // Remove the auto-close functionality for mobile
    // Modal should work on all screen sizes
  });
  
  // Handle keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('active')) return;
    
    if (e.key === 'ArrowLeft') {
      modalPrevBtn.click();
    } else if (e.key === 'ArrowRight') {
      modalNextBtn.click();
    } else if (e.key === 'Escape') {
      closeModal();
    }
  });
});
